<div class="page-wrapper">
  <app-breadcrumbs></app-breadcrumbs>
  <section>
    <div class="content-wrapper">
      <h1 class="title">{{ policySummaryData().title }}</h1>
      <p class="intro">{{ policySummaryData().intro }}</p>
    </div>
    <div class="content-wrapper">
      <div class="options">
        <ng-container *ngFor="let summary of policySummaryData().languages">
          <div class="policy">
            <p class="language">{{ summary.language }}</p>
            <a
              *ngIf="
                summary.policy_document.data?.attributes?.file?.data?.attributes
                  ?.url
              "
              [href]="
                summary.policy_document.data?.attributes?.file?.data?.attributes
                  ?.url
              "
            >
              <button>Download</button>
            </a>
          </div>
          <div class="horizontal-seperator"></div>
        </ng-container>
      </div>
    </div>
  </section>
</div>
